import React from 'react'
import PropTypes from 'prop-types'

import { MenuItem } from '@material-ui/core'

class TableDropdownItem extends React.PureComponent {
  handleOnClick = () => {
    this.props.handleClose()
    if (this.props.onClick) {
      window.setTimeout(() => {
        this.props.onClick()
      }, 300)
    }
  }

  render = () => {
    const { children } = this.props

    return <MenuItem onClick={this.handleOnClick}>{children}</MenuItem>
  }
}

TableDropdownItem.propTypes = {
  handleClose: PropTypes.func,
  onClick: PropTypes.func
}

export default TableDropdownItem
